<!-- 修改内部备注 | 修改备注 -->
<template>
  <div class="changeDetailRemarks cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig"/> 
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      formConfig: {
        formData: [
          {
            style: 'textarea',
            label: t('备注'), // 备注
            value: 'REMARK',
            width: '24'
          },
        ],
        formValue: {
          REMARK: '', // 备注
        }
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.determine();
            }, // 按钮点击事件
          }
        ],
      },
      loading: false,
    }
  },
  props: {
    componentData: {
      type: Object,
    }
  },
  mounted() {
    this.formConfig.formValue.REMARK = this.componentData.itemList.RESERVE_VARCHAR02
  },
  methods: {
    async determine() {
      const { orderId, itemList } = this.componentData
      const fromdata = new FormData();
      let param = {
        orderId,
        itemIdList: [itemList.ID],
        remark: this.formConfig.formValue.REMARK
      }
      fromdata.append('param', JSON.stringify(param));
      this.loading = true;
      const { data: { code, message }} = await this.service.orderCenter.updateItemRemark(param)
      this.loading = false;
      this.$parent.$parent.closeConfirm();
      if (code === 0) {
        this.$Message.success(message);
        // this.$parent.$parent.$parent.$parent.load();
        // this.$parent.$parent.$parent.$parent.selection = [];
        this.$parent.$parent.$parent.$parent.$refs.essentialInfo.$refs.cusOrderItem.request()
        this.$parent.$parent.$parent.$parent.$refs.essentialInfo.$refs.cusOrderItem.checkSelection = []
      } else {
        $fcError(message)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.cus-modal {
  /deep/ .business-form-main {
    .ark-form-item-label {
      width: 50px !important;
    }
    .ark-form-item-content {
      margin-left: 50px !important;
    }
  }
}
</style>
